
import { Vue, Component, Prop } from 'vue-property-decorator'
import i18n from '@/plugins/i18n'

const $t = (localePath: string) => {
  return i18n.t(localePath).toString()
}

@Component({})
export default class AlertDialog extends Vue {
  @Prop({ type: String }) title?: string
  @Prop({ type: String }) message?: string
  @Prop({ type: String, default: $t('dialogs_alert.script.prop.done') })
  okButtonText?: string
  @Prop({ type: String, default: 'done' }) okButtonIcon?: string
  @Prop({ type: String, default: 'primary' }) okButtonColor?: string
}
